
<div class="flex p-2">
    <div class="flex-1 flex align-items-center justify-content-center">
        <h4>We're sorry a fatal exception has occurred in the application and needs to be restarted.  This error has been recorded.  Please logout and login back in again, and then retry your action.</h4>>
    </div>
</div>